module.exports = __webpack_public_path__ + "img/active-list1.a52e954a.png";